module.exports = __webpack_public_path__ + "media/entities/2103-25f57c35.png";